<template>
    <div class="qksm qksm4">
        <p><b>（四）政府性基金预算收支情况</b></p>
        <p v-if="num(T6.总计)==0">
            {{$store.state.divData.divname}}2021年没有使用政府性基金预算拨款安排的支出。
        </p>
        <div class="nogap" v-else>
            <p>
                2021年政府性基金收入预算{{isMoney(T6.总计)}}万元，
                <span class="hide_pdf">
                    （去年预算数<reason type="money" classname="qksm money editLast" name="T6总计last" v-model:value="qksm['T6总计last']"></reason>万元）
                </span>
                <span v-if="num(T6.总计).toFixed(2)==num(qksm['T6总计last']).toFixed(2)">
                    与上年预算数相同。
                </span>
                <span v-else>
                    <span v-if="num(qksm['T6总计last'])==0">
                        （去年预算数为0万元，无法计算增减比率），
                    </span>
                    <span v-else>
                        比上年{{growthRatioText(T6.总计,qksm['T6总计last'])}}，
                    </span>
                    主要是<reason type="textarea" classname="qksm widest because" name="T6原因" v-model:value="qksm['T6原因']"></reason>
                </span>
            </p>
            <p>
                2021年政府性基金支出预算为{{isMoney(T6.总计)}}万元，具体情况如下：
            </p>
            <p v-for="(item,idx) in T6.leiItems">
                {{T6.leiItems.length>1 ? (idx+1)+"." :""}}{{(item.f).replace("支出","")}}（类）支出{{isMoney(item.g)}}万元，主要用于<reason type="textarea" classname="qksm widest because" :name="'T6用于'+compact(item.c)" v-model:value="qksm['T6用于'+compact(item.c)]"></reason>
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm4",
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
            }
        },
        props: {
            T6: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
    };
</script>
